module.exports = __webpack_public_path__ + "img/about-top-image-mobile.e24f746e.png";